import React from "react";
import { ErrorLayout } from "component/layout/error";

const Component = () => (
	<ErrorLayout
		title="Page Not Found"
		header="404"
		message="We couldn't find that page."
		subtitle="Double-check the URL, or head back to the homepage to find what you're looking for."
	/>
)

export const NotFoundPage = Component;